import React from "react";
import { Navbar, Footer, } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { Helmet } from "react-helmet-async";
import '../general/General.css';
import DonationDetails from "./DonationDetails";
import { Breadcrumbs } from '../../components/shared';

const UserDonations = () => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
  return (
    <>
      <Helmet>
        <title>நன்கொடைகள்</title>
        <link rel="canonical" href="/user/profile" />
      </Helmet>
      <Navbar />


      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <div className="detail-card">
              <DonationDetails />
            </div>

          </div>
        </div>
      </div>



      <Footer />
    </>
  );
};

export default UserDonations;
